const users = [
    {
        id: 0,
        email: 'nawal@gmail.com',
        username: 'Nawal',
        password: '123456',
        settings: {
            language: "English (US)",
            currency: "USD",
            subscribtion: "Basic"
        }
    },
    {
        id: 1,
        email: 'Catherine@gmail.com',
        username: 'Catherine',
        password: '123456',
        settings: {
            language: "English (US)",
            currency: "USD",
            subscribtion: "Basic"
        }

    }
];

export default users;